// Param typed as the minimal shape used (not the full per-procedure `Query<...>`) so one predicate
// is structurally assignable to every procedure's differently-typed `invalidate` filters.
export const touchesVariant =
  (touched: ReadonlySet<string>) =>
  (query: { queryKey: readonly unknown[] }): boolean => {
    const input = (query.queryKey[1] as { input?: unknown } | undefined)?.input as
      | { variantId?: unknown; variantIds?: unknown }
      | undefined
    if (!input) return true // no input on the key (e.g. a bare list query) — invalidate defensively
    if (typeof input.variantId === "string") return touched.has(input.variantId)
    if (Array.isArray(input.variantIds)) return input.variantIds.some((id) => touched.has(id))
    return true
  }

// For membership changes: `getDemandTotals` resolves a collection's variants server-side, so its key
// names collections, not the variants that moved in or out.
export const touchesCollection =
  (collectionIds: readonly number[]) =>
  (query: { queryKey: readonly unknown[] }): boolean => {
    const input = (query.queryKey[1] as { input?: unknown } | undefined)?.input as
      | { collectionIds?: unknown }
      | undefined
    if (!Array.isArray(input?.collectionIds)) return true
    return input.collectionIds.some((id) => collectionIds.includes(id))
  }
